import { render, staticRenderFns } from "./ReferenceInformation.vue?vue&type=template&id=e727c6b4&scoped=true&lang=pug&"
import script from "./ReferenceInformation.vue?vue&type=script&lang=ts&"
export * from "./ReferenceInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceInformation.vue?vue&type=style&index=0&id=e727c6b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e727c6b4",
  null
  
)

export default component.exports